var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFb(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.28 17.812l.57-3.8h-3.567v-2.467c0-1.04.498-2.053 2.096-2.053H22V6.257S20.529 6 19.122 6c-2.937 0-4.857 1.82-4.857 5.116v2.896H11v3.8h3.265V27h4.018v-9.188h2.996z",
    fill: "#fff"
  })));
}

export default SvgFb;